import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);

const APPROVED_CONTACT = {
  "site.phone": "+1 242-436-1317",
  "site.email": "info@bahamaskidneyassociation.org",
  "site.address": "",
};

const PLACEHOLDER_CONTACT = {
  "site.phone": "(242) 123-4567",
  "site.email": "info@bahamaskidney.org",
  "site.address": "P.O. Box N-1234, Nassau, Bahamas",
};

const FALLBACK = {
  settings: {
    "site.name": "Bahamas Kidney Association",
    ...APPROVED_CONTACT,
  },
  nav: [],
  donation_configured: false,
};

function publicSetting(settings, key, fallback = "") {
  const value = settings?.[key];
  if (Object.prototype.hasOwnProperty.call(APPROVED_CONTACT, key)) {
    if (value == null || value === "" || value === PLACEHOLDER_CONTACT[key]) {
      return APPROVED_CONTACT[key];
    }
  }
  return value ?? fallback;
}

export function SiteProvider({ children }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    api
      .get("/public/bootstrap")
      .then((r) => alive && setData(r.data))
      .catch(() => alive && setData(FALLBACK));
    return () => {
      alive = false;
    };
  }, []);

  const value = useMemo(() => {
    const d = data || FALLBACK;
    return {
      ready: Boolean(data),
      nav: d.nav || [],
      settings: d.settings || {},
      donationConfigured: Boolean(d.donation_configured),
      s: (key, fallback = "") => publicSetting(d.settings, key, fallback),
    };
  }, [data]);

  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}

export function useSite() {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSite must be used inside SiteProvider");
  return ctx;
}
